module.exports = __webpack_public_path__ + "img/pilcrow-square.1ce61464.svg";